import React from 'react';
import { AI_ASSISTANT } from '@/lib/ai-chat/constants';
import { MarkdownRenderer } from './MarkdownRenderer';

interface StreamingMessageProps {
  content: string;
}

export const StreamingMessage: React.FC<StreamingMessageProps> = ({ content }) => {
  return (
    <div className="flex gap-2 mb-3">
      {/* AI Avatar */}
      <div className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center ring-1 ring-border">
        <img
          src="/media/tag-innovation-logo.png"
          alt={AI_ASSISTANT.name}
          className="h-4 w-4 rounded-sm"
        />
      </div>

      {/* Streaming content bubble */}
      <div className="bg-muted rounded-lg px-3 py-2 max-w-[85%] text-sm">
        <MarkdownRenderer content={content} />
        {/* Streaming cursor */}
        <span className="inline-block w-2 h-4 ml-0.5 bg-primary/60 animate-pulse" />
      </div>
    </div>
  );
};

export default StreamingMessage;
